<template>
    <div class="animated fadeIn">
        <div class="card card-green">
            <div class="card-body">
                <DocumentWin v-bind:childId="$route.params.userId" v-bind:type="'normal'"></DocumentWin>
            </div>
        </div>
    </div>
</template>
  
<script>

import DocumentWin from './documents/DocumentsWin.vue';

export default
    {
        name: 'UserDocuments',
        components:
        {
            DocumentWin,
        },
    };
</script>
  